import templateUrl from "emun.retailer/retailer-forms-prompt.htm";
import controller from "emun.retailer/retailer-forms-prompt.controller";
import open from "webmodals/open";
import scss from 'emun.auth/pre-authorized-credit-prompt.client.scss'

export default ({
	size = "md pre-authorized-credit-prompt",
	backdrop = "static",
	placement = "center",
	preventAutoHeight = true,
	retailer = {},
	form = {},
	email = "",
	title = "Request form submission",
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		resolve: {
			preventAutoHeight: () => preventAutoHeight,
			title: () => title,
			retailer: () => retailer,
			email: () => email,
			form: () => form
		},
		bindToController: true,
		controllerAs: "$ctrl"
	}).result;
